import {
  Action,
  ActionProps,
  Flex,
  Icon,
  IconName,
  Spinner,
  Tooltip,
  useTooltip,
} from '@revolut-internal/ui-kit'
import styled from 'styled-components'

const ToolbarButton = styled(Action)`
  padding: 5px 8px;
`

type Props = ActionProps & {
  iconName: IconName
  tooltipText: string | null
  pending?: boolean
}

export function TooltipButton({
  iconName,
  title,
  tooltipText,
  onClick,
  pending,
  disabled,
}: Props) {
  const tooltip = useTooltip()
  return (
    <>
      <Flex {...tooltip.getAnchorProps()}>
        <ToolbarButton disabled={disabled} onClick={onClick} color="accent" title={title}>
          {pending ? <Spinner size={16} /> : <Icon name={iconName} size={16} />}
        </ToolbarButton>
      </Flex>

      {tooltipText && <Tooltip {...tooltip.getTargetProps()}>{tooltipText}</Tooltip>}
    </>
  )
}
